import { Box, FormControl, FormHelperText, Tooltip, Flex, Stack, IconButton, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { MdCleaningServices, MdDelete } from 'react-icons/md';
import { useRef } from 'react';
import { FaUndoAlt } from 'react-icons/fa';
import CanvasDraw from 'react-canvas-draw';
import c from '../../constant';

const CanvasFormField = ({ label = null, name = null, canvasWidth = 288, canvasHeight = 162, required = false }) => {
	const canvasRef = useRef(null);
	const { t } = useTranslation();

	return (
		<>
			<Field name={name}>
				{({ form, meta }) => {
					return (
						<Box mb="4">
							<FormControl id={name}>
								{label && (
									<FormLabel>
										{t(label)}
										{required && <span style={{ color: 'red' }}>*</span>}
									</FormLabel>
								)}
								<Flex flexDirection="column" justifyContent="center" alignItems="flex-start" mb={4}>
									<Stack direction="row-reverse" spacing={2} width={canvasWidth} mb="4px">
										<Tooltip label={t('Clear')}>
											<IconButton
												variant="outline"
												width="30px"
												height="30px"
												borderColor="gray.200"
												icon={<MdDelete size={18} color="gray" />}
												onMouseDown={() => {
													canvasRef?.current?.clear();
													form?.setFieldValue(name, '');
												}}
											/>
										</Tooltip>
										<Tooltip label={t('Clean')}>
											<IconButton
												variant="outline"
												width="30px"
												height="30px"
												borderColor="gray.200"
												icon={<MdCleaningServices size={16} color="gray" />}
												onMouseDown={() => {
													canvasRef?.current?.eraseAll();
												}}
											/>
										</Tooltip>
										<Tooltip label={t('Undo')}>
											<IconButton
												variant="outline"
												width="30px"
												height="30px"
												borderColor="gray.200"
												icon={<FaUndoAlt size={14} color="gray" />}
												onMouseDown={() => {
													canvasRef?.current?.undo();
												}}
											/>
										</Tooltip>
									</Stack>
									<Box borderWidth={1} borderColor="gray.200" borderRadius={2}>
										<CanvasDraw
											ref={canvasRef}
											canvasWidth={canvasWidth}
											canvasHeight={canvasHeight}
											brushColor={c.penColor}
											brushRadius={1}
											lazyRadius={0}
											onChange={(canvasDraw) => {
												if (canvasDraw?.lines?.length > 0) {
													form?.setFieldValue(name, canvasDraw?.getDataURL());
												} else {
													form?.setFieldValue(name, '');
												}
											}}
										/>
									</Box>
								</Flex>
								{meta.touched && meta.error && (
									<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
										{t(label)} {t('is')} {t(meta.error)}
									</FormHelperText>
								)}
							</FormControl>
						</Box>
					);
				}}
			</Field>
		</>
	);
};

export default CanvasFormField;
